import { render, staticRenderFns } from "./StatePremiumTable.vue?vue&type=template&id=0354453d"
import script from "./StatePremiumTable.vue?vue&type=script&lang=js"
export * from "./StatePremiumTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports